{"rating":"4.9","reviewCount":"140","fetchedAt":"2026-10-11T15:51:41.880Z","source":"place-details"}